import './pos-pad.scss';

/*
 * pos-pad component.
 */
angular.module('posApp').directive('posPad', () => ({
  restrict: 'E',

  scope: true,

  template: require('./pos-pad.html').default,

  link: function ($scope, element, attrs) {},
}));
